module.exports = __webpack_public_path__ + "static/media/coloured-card.c39e194a.jpg";